// Uygulama genelinde kullanılacak ana renkler ve gradientler

const colors = {
  // Ana mavi tonları (Tailwind ve Login.js uyumlu)
  primary: "#2563eb", // blue-700
  primaryDark: "#1e40af", // blue-800
  primaryLight: "#60a5fa", // blue-400
  primaryDarker: "#1e3a8a", // blue-900
  primaryLighter: "#bfdbfe", // blue-200
  primaryMid: "#3b82f6", // blue-500

  // Arka plan ve gradientler
  backgroundGradient: "linear-gradient(135deg, #2563eb 0%, #60a5fa 100%)",
  backgroundSoft: "#f8fafd",
  backgroundLogin: "linear-gradient(to bottom right, #bfdbfe, #60a5fa)", // blue-200 to blue-400
  backgroundLoginCard: "linear-gradient(to bottom right, #1e40af, #2563eb)", // blue-800 to blue-700

  // Border ve input
  border: "#e0e7ef",
  inputBg: "#f1f5f9", // gray-100
  inputBorder: "#bfdbfe", // blue-200
  inputFocus: "#60a5fa", // blue-400
  inputPlaceholder: "#94a3b8", // gray-400
  inputText: "#1e293b", // gray-800

  // Text ve başlıklar
  white: "#fff",
  grayText: "#6b7280", // gray-500
  heading: "#1e293b", // gray-800

  // Butonlar
  buttonPrimary: "#1e40af", // blue-800
  buttonPrimaryHover: "#2563eb", // blue-700
  buttonDisabled: "#93c5fd", // blue-300

  // Chip ve badge renkleri
  chipPatientBg: "#dbeafe",
  chipPatientText: "#2563eb",
  chipPharmacistBg: "#fce4ec",
  chipPharmacistText: "#be185d",
  chipPendingBg: "#fffbe6",
  chipPendingText: "#b26a00",
  chipApprovedBg: "#e6ffed",
  chipApprovedText: "#1b5e20",
  chipRejectedBg: "#ffebee",
  chipRejectedText: "#b71c1c",
  chipExpiredBg: "#ececec",
  chipExpiredText: "#616161",

  // Alert ve durum renkleri
  success: "#22c55e", // green-500
  successHover: "#16a34a", // green-600
  error: "#ef4444", // red-500
  errorHover: "#dc2626", // red-600
  warning: "#f59e42", // amber-500
  info: "#3b82f6", // blue-500
  grey: "#6b7280", // gray-500
  lightBlue: "#f1f5f9", // slate-100

  // Ek renk tanımları
  secondary: "#be185d", // pink-700
};

export default colors;
